import { render, staticRenderFns } from "./public-declare.vue?vue&type=template&id=bc0479e0&scoped=true&"
import script from "./public-declare.vue?vue&type=script&lang=js&"
export * from "./public-declare.vue?vue&type=script&lang=js&"
import style0 from "./public-declare.vue?vue&type=style&index=0&id=bc0479e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0479e0",
  null
  
)

export default component.exports